import i18n from 'i18nextInstance';

export const HEADERS = [
    { key: 'patient_identification', label: i18n.t('DNIPaciente') },
    { key: 'patient_last_name', label: i18n.t('Apellido') },
    { key: 'patient_first_name', label: i18n.t('Nombre') },
    { key: 'patient_gender', label: i18n.t('Sexo') },
    { key: 'patient_position', label: i18n.t('Cargo') },
    { key: 'diagnoses', label: i18n.t('Diagnósticos') },
    { key: 'license_reasons', label: i18n.t('Licencias') }
];
